import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  createBankAccount,
  deleteBankAccounts,
  getBankAccountApi,
} from "services/apibankAccount";

export function useBankAccountCreate() {
  const queryClient = useQueryClient();

  const { mutate: createBank, isLoading: isCreating } = useMutation({
    mutationFn: createBankAccount,
    onSuccess: () => {
      toast.success("Bank detail successfully created");
      queryClient.invalidateQueries({ queryKey: ["bankDetails"] });
    },
    onError: (err) => toast.error(err.toast),
  });

  return { isCreating, createBank };
}

export function useBankAccountDelete() {
  const queryClient = useQueryClient();

  const { mutate: deleteBank, isLoading: isDeleting } = useMutation({
    mutationFn: deleteBankAccounts,
    onSuccess: () => {
      toast.success("Bank detail successfully updated");
      queryClient.invalidateQueries({ queryKey: ["bankDetails"] });
    },
    onError: (err) => toast.error(err.message),
  });

  return { isDeleting, deleteBank };
}

export function useBankAccounts() {
  const {
    isLoading,
    data: account, // Provide a default value
    error,
  } = useQuery({
    queryKey: ["bankDetail"],
    queryFn: getBankAccountApi,
  });

  return { isLoading, error, account };
}
